import Rest from '../Rest'

export default class OccupationService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/occupations'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
